import React from 'react';
import { useNavigate } from 'react-router-dom';
import AnimatedHeadingSequence from '../components/GreetingAnimation/AnimatedHeadingSequence';

const MainPage: React.FC = () => {
 const navigate = useNavigate();

 return (
   <div className="relative isolate bg-[#EDEDE5] min-h-screen">
     {/* Top Navigation - Hidden on mobile */}
     <div className="hidden md:flex justify-end items-center p-6 absolute top-0 right-0 z-10">
       <button
         onClick={() => navigate('/faq')}
         className="text-[#475802] text-lg font-semibold hover:text-green-900 hover:underline mr-6"
       >
         FAQs
       </button>
       <button
         onClick={() => navigate('/waitlist')}
         className="px-6 py-2 bg-[#91A93D] text-white rounded-full hover:bg-[#475802] transition-colors"
       >
         Join Waitlist
       </button>
     </div>

     {/* Main Content */}
     <div className="min-h-screen flex flex-col lg:flex-row items-center justify-center max-w-7xl mx-auto px-4">
       {/* Left Side */}
       <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-center justify-center">
         <img 
           src="/images/logo.png" 
           alt="Smart Farm Logo" 
           className="w-48 h-48 sm:w-64 sm:h-64 lg:w-80 lg:h-80 object-contain mb-4"
         />

         {/* Mobile UI - Visible only on mobile */}
         <div className="block lg:hidden mb-8">
           <img 
             src="/images/introscreens.png" 
             alt="Product Preview" 
             className="w-[300px] sm:w-[280px] md:w-[320px] object-contain transform rotate-3"
           />
         </div>
         
         <div className="max-w-md text-center">
           <AnimatedHeadingSequence
             headings={[
               'Smart Farm Management',
               'Crop and Livestock Husbandry',
               'Bookkeeping and Accounting',
               'Access to Loans',
               'Agro-Input Sales',
             ]}
             className="text-lg sm:text-xl lg:text-2xl mb-4 lg:mb-7 font-semibold text-gray-900 leading-snug tracking-wide font-sedan"
           />
           
           <p className="text-base sm:text-lg lg:text-xl text-gray-700 font-medium mt-4 mb-6 font-sedan">
             We Are Almost Ready to Launch!
           </p>

           {/* Action Buttons */}
           <div className="flex flex-col sm:flex-row gap-3 justify-center mt-6">
             <button
               onClick={() => navigate('/waitlist')}
               className="px-6 sm:px-8 py-2.5 bg-[#91A93D] text-white font-semibold rounded-full shadow-md hover:bg-[#475802] transition-all duration-300"
             >
               Join Waitlist
             </button>
             <button
               onClick={() => navigate('/faq')}
               className="px-6 sm:px-8 py-2.5 border-2 border-[#91A93D] bg-white text-[#91A93D] font-semibold rounded-full shadow-md hover:bg-[#8A9A5B] hover:text-white transition-all duration-300"
             >
               Learn More
             </button>
           </div>
         </div>
       </div>

       {/* Right Side - Hidden on mobile */}
       <div className="hidden lg:flex w-1/2 justify-center items-center mt-8 lg:mt-0">
         <img 
           src="/images/introscreens.png" 
           alt="Product Preview" 
           className="w-[550px] object-contain transform rotate-3"
         />
       </div>
     </div>
   </div>
 );
};

export default MainPage;